import { FieldHtmlNameUtil, HekateDisplayForm } from 'www-shared';
import { Ref } from 'vue';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import UnifiedSignupScreenName from '../UnifiedSignupScreenName';
import UnifiedSignupSessionInfo from '../session-info/UnifiedSignupSessionInfo';
import UnifiedSignupAgent from '../UnifiedSignupAgent';
import AbstractSignupScreenWithNewsletterForm from './AbstractSignupScreenWithNewsletterForm';

export default class SubmittingFormLoadingSignupScreen extends AbstractSignupScreenWithNewsletterForm {
  public screenName: UnifiedSignupScreenName = 'uss-signup-email-status';

  private readonly onUpdatePage: VoidFunction;

  private readonly isNextButtonHidden: Ref<boolean>;

  constructor({
    sessionInfo,
    formDefinition,
    onUpdatePage,
    isBackButtonHidden,
    isNextButtonHidden,
    signupSurveyDiv,
  }: {
    sessionInfo: Ref<UnifiedSignupSessionInfo>;
    formDefinition: Ref<HekateDisplayForm>;
    onUpdatePage: VoidFunction,
    isBackButtonHidden: Ref<boolean>,
    isNextButtonHidden: Ref<boolean>,
    signupSurveyDiv: HTMLDivElement | null,
  }) {
    super({
      sessionInfo, formDefinition, isBackButtonHidden, signupSurveyDiv,
    });
    this.onUpdatePage = onUpdatePage;
    this.isNextButtonHidden = isNextButtonHidden;
  }

  // eslint-disable-next-line class-methods-use-this
  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    return [];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return this.getVisibleComponents();
  }

  // eslint-disable-next-line class-methods-use-this
  public getProgress(): number {
    throw new Error('not implemented');
  }

  // eslint-disable-next-line class-methods-use-this
  public updateProgress(): void {
    const container = document.querySelector('.hekate-progress-bar') as HTMLDivElement;
    container.classList.remove('d-none');
  }

  public predicate(): boolean {
    const {
      submitFormResult, emailStatus,
    } = this.sessionInfo.value;

    if (emailStatus !== null || submitFormResult === null || !submitFormResult.isSuccess || submitFormResult.statusCode !== 201) {
      return false;
    }

    return true;
  }

  public async initWatchers(): Promise<void> {
    document.querySelectorAll('[hekate-data="email"]').forEach((elm) => {
      const firstName = this.getField(FieldHtmlNameUtil.email).val;
      elm.textContent = `${firstName}`;
    });
    this.isNextButtonHidden.value = true;
    await this.pollEmailStatus();
    this.onUpdatePage();
  }

  private async pollEmailStatus() {
    const email = this.getField(FieldHtmlNameUtil.email).val as string;
    const job: Promise<boolean> = new Promise((res) => {
      let maxTries = 30;
      const interval = setInterval(async () => {
        maxTries -= 1;
        if (maxTries < 1) {
          // eslint-disable-next-line no-console
          console.warn('polling status.emailStatusState');
          this.sessionInfo.value.emailStatus = 'INVALID';
          clearInterval(interval);
          res(true);
        }
        const status = await UnifiedSignupAgent.emailStatus({
          email,
        });
        // eslint-disable-next-line no-console
        console.log('status.emailStatusState', status.emailStatusState);
        if (status.emailStatusState === 'PENDING_VERIFICATION') {
          return;
        }
        this.sessionInfo.value.emailStatus = status.emailStatusState;
        clearInterval(interval);
        res(true);
      }, 2000);
    });
    await job;
  }

  // eslint-disable-next-line class-methods-use-this
  public async toNextScreen(): Promise<boolean> {
    return true;
  }

  public async initListeners({ partialDiv }: { partialDiv: HTMLDivElement; }): Promise<void> {
    await super.initListeners({ partialDiv });
  }
}
